import { api } from './api';
import { ReleaseTypeDto } from '@/shared/types/api';

/**
 * Release Type metadata (SC-300). Reads are available to any authenticated user (assignment
 * dropdown, feed filter); create/update/delete require the Admin role server-side.
 */
export const releaseTypeApi = {
  list: async (includeInactive = false): Promise<ReleaseTypeDto[]> =>
    (
      await api.get<ReleaseTypeDto[]>('/releasetypes', {
        params: includeInactive ? { includeInactive: true } : undefined,
      })
    ).data,

  create: async (name: string, description?: string | null): Promise<ReleaseTypeDto> =>
    (await api.post<ReleaseTypeDto>('/releasetypes', { name, description })).data,

  update: async (
    id: number,
    name: string,
    description: string | null | undefined,
    isActive: boolean
  ): Promise<ReleaseTypeDto> =>
    (await api.put<ReleaseTypeDto>(`/releasetypes/${id}`, { name, description, isActive })).data,

  remove: async (id: number): Promise<void> => {
    await api.delete(`/releasetypes/${id}`);
  },

  /** Assign (or clear, with null) the Release Type value on a feed item. */
  assign: async (feedItemId: number, releaseType: string | null): Promise<void> => {
    await api.put(`/feeditems/${feedItemId}/release-type`, { releaseType });
  },
};
